export default __webpack_public_path__ + "static/media/hand.86c7a6f7.svg";